import { Avatar, AvatarProps } from "@mui/material";

import baseStyleImage from "@/assets/styles/base_style.png";

interface MinimalFile {
  thumbnails?: {
    small?: { url?: string };
    medium?: { url?: string };
    large?: { url?: string };
  };
  url?: string;
  name?: string;
}

interface MinimalFeaturedFile {
  file?: MinimalFile;
}

interface StyleAvatarProps extends Omit<AvatarProps, "src" | "alt" | "style"> {
  style?: {
    id: string;
    name: string;
    featuredFiles?: MinimalFeaturedFile[];
  };
}

export const StyleAvatar = (props: StyleAvatarProps) => {
  const { style, variant = "square", sx, ...rest } = props;
  const featuredFile = style?.featuredFiles?.[0]?.file;
  const src =
    featuredFile?.thumbnails?.small?.url ||
    featuredFile?.thumbnails?.medium?.url ||
    featuredFile?.thumbnails?.large?.url ||
    featuredFile?.url ||
    baseStyleImage;
  return (
    <Avatar
      variant={variant}
      src={src}
      alt={style?.name || "Style icon"}
      {...rest}
      sx={{
        width: 24,
        height: 24,
        flexShrink: 0,
        borderRadius: variant === "rounded" ? "50%" : 1,
        ...(sx ?? {}),
      }}
    />
  );
};
